module.exports = __webpack_public_path__ + "static/img/porquenos.d76cc92.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/porquenos.jpeg
// module id = mzUv
// module chunks = 1